import { render, staticRenderFns } from "./RutaPivotTable.vue?vue&type=template&id=716bd9b4"
import script from "./RutaPivotTable.vue?vue&type=script&lang=js"
export * from "./RutaPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports